import React from "react";
import { Typography } from "@mui/material";
import { PeriodMap } from "../PeriodMap";
import PhaseAccordian from "../../PhaseAccordian";
import AssessmentModal from "./AssessmentModal";

function Assessment({
  collapse,
  handleTabEdit,
  onChangeAssessment,
  TransactionID,
  ParameterRatingScaleID,
  ParameterTargetDataType,
  ParameterTargetRule,
  ParameterWeightage,
  ParameterAchievementDataType,
  AssessmentPeriodType,
  AssessmentPeriodValue,
  AssessmentStartDate,
  AssessmentEndDate,
  ParameterTargets,
  Workflow,
  ParameterActorAssessments,
  onSave,
  AssessmentDocumentID,
  actorAssessment,
  Achievements,
}) {
  let actorAssessmentForParams;
  if (actorAssessment)
    actorAssessmentForParams = actorAssessment[AssessmentDocumentID];
  if (actorAssessmentForParams)
    actorAssessmentForParams = actorAssessmentForParams[TransactionID];

  const { enabled: TargetEnabled } = ParameterTargetRule;

  if (
    !ParameterTargetRule ||
    !AssessmentPeriodType ||
    !AssessmentPeriodValue ||
    !ParameterTargets ||
    !ParameterActorAssessments ||
    (TargetEnabled === "E" &&
      (!ParameterTargetDataType || !ParameterAchievementDataType))
  ) {
    return (
      <div className="Flex">
        <Typography>Data missing for assessment component</Typography>
      </div>
    );
  }

  return (
    <div>
      <PhaseAccordian
        collapse={collapse}
        TransactionID={TransactionID}
        title={
          AssessmentPeriodType === "I"
            ? `${PeriodMap[AssessmentPeriodType].label} (${AssessmentPeriodValue})`
            : PeriodMap[AssessmentPeriodType].values[AssessmentPeriodValue]
        }
        caption={`${AssessmentStartDate} - ${AssessmentEndDate}`}
        completed={Workflow?.WorkflowStatus === "C"}
        weight={ParameterWeightage}
      >
        <AssessmentModal
          AssessmentPeriod={ParameterTargets.find(
            (pt) => pt.TargetPeriodValue === AssessmentPeriodValue
          )}
          Achievements={Achievements}
          onChangeAssessment={onChangeAssessment}
          handleTabEdit={handleTabEdit}
          AssessmentData={ParameterActorAssessments}
          TargetDataType={ParameterTargetDataType}
          AchievementDataType={ParameterAchievementDataType}
          ParameterWeightage={ParameterWeightage}
          Workflow={Workflow}
          TargetRule={ParameterTargetRule}
          RatingScaleID={ParameterRatingScaleID}
          actorAssessmentForParams={actorAssessmentForParams}
        />
      </PhaseAccordian>
    </div>
  );
}

export default Assessment;
